module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/banner@3x-7f3821de6678ed70833f39a148216377.png";